// components/ProfileBasicInfo.jsx
import React from 'react';
import { Translate } from 'react-jhipster';
import { Row, Col } from 'reactstrap';

const ProfileBasicInfo = ({ userProfileEntity }) => {
  return (
    <>
      <h3>Basic Information</h3>
      <Row className="pt-3">
        <Col sm="3">
          <dt>
            <span id="dateOfBirth">
              <span>Year Of Birth</span>
            </span>
          </dt>
          <dd className="fw-medium">{userProfileEntity[0]?.year}</dd>
        </Col>

        <Col sm="6">
          <dt>
            <span id="occupation">
              <span>Area of Expertise</span>
            </span>
          </dt>
          <dd className="fw-medium">{userProfileEntity[0]?.occupation}</dd>
        </Col>
      </Row>
    </>
  );
};

export default ProfileBasicInfo;
